import React from 'react';
import {Alert} from '@material-ui/lab';
import {Snackbar} from '@material-ui/core';

/**
 * Snackbar for handling alerts
 * @param visible
 * @param severity
 * @param onClose
 * @constructor
 */
const StyledSnackbar = ({visible, severity, onClose}: {
  visible: boolean,
  severity: 'success' | 'info' | 'warning' | 'error'
  onClose: any
}) => {
  return (
      <Snackbar open={visible} autoHideDuration={5000}
                onClose={onClose}>
        <Alert variant={'filled'} severity={severity}>
          Что то пошло не так, попробуйте позже
        </Alert>
      </Snackbar>
  );
};

export default StyledSnackbar;
